import { env } from '@/config/env';

const colors = {
  OlybetGrey06: '#3B3B54',
  OlybetGrey07: '#292935',
  OlybetPrimaryRed: env.TENANT === 'spain' ? '#B58344' : '#F73535',
  OlybetTertiaryButtonText: '#073C1C',
  OlybetSecondaryBlue: '#33CFFF',
  OlybetDarkNavi: '#09214C',

  darkBlue: '#1A212A',
  absoluteWhite: '#FFFFFF',
  semiWhite: '#F2F2F2',
  poisonGreen: '#08F9AE',
  mainOrange: '#FF8A01',
  dark: '#101317',
  absoluteBlack: '#000000',
  neutralGrey: '#8D9DA8',
  errorRed: env.TENANT === 'spain' ? '#B58344' : '#FF4E64',
  poisonYellow: '#B6EB1E',

  secondaryGrey: '#484d55',
  semiGrey: 'rgba(141, 157, 168, 0.50)',
  semiDarkBg: 'rgba(0, 0, 0, 0.5)',
  opacityGrey: 'rgba(255, 255, 255, 0.70)',
  lightGrey: '#CBCBCB',
  darkGrayishBlue: '#62707B',
  avertaGrey: '#E2E2E2',

  primaryGradient: 'linear-gradient(90deg, #0CD664 43.75%, #1A212A 81.4%)',
  secondaryGradient: 'linear-gradient(90deg, #0CD664 15.59%, #1A212A 81.4%)',
  tertiaryGradient: 'linear-gradient(90deg, #0CD664 43.75%, #1A212A 81.4%)',
  quarterlyGradient: 'linear-gradient(90deg, #1A212B 0%, #136740 100%)',

  greenProgressGradient: 'linear-gradient(180deg, #47B355 0%, #358B40 100%)',
  redProgressGradient:
    env.TENANT === 'spain'
      ? 'linear-gradient(180deg, #B58344 0%, #8A6233 100%)'
      : 'linear-gradient(180deg, #FF4E64 0%, #BF3547 100%)',
};

export default colors;
